import { render, staticRenderFns } from "./RadioItems.vue?vue&type=template&id=4e8fcbc1&"
import script from "./RadioItems.vue?vue&type=script&lang=ts&"
export * from "./RadioItems.vue?vue&type=script&lang=ts&"
import style0 from "./RadioItems.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports